import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../core/services/alert.service';
import { Member } from '../core/models/member.model';
import { DataService } from '../core/services/data.service';
import { PushService } from '../core/models/push.service';
import { Notification } from '../core/models/notification.model';
import { CommonService } from '../core/services/common.service';
import { DbService } from '../core/services/db.service';

@Component({
  selector: 'app-push-modal',
  templateUrl: './push-modal.component.html',
  styleUrls: ['./push-modal.component.scss'],
})
export class PushModalComponent {
  title = '';
  content = ''
  members: Member[];
  constructor(public modalService: NgbModal, private db: DbService, private commonService: CommonService, private pushService: PushService, private alertService: AlertService, private dataService: DataService) { }

  //푸시 보내기
  sendPush() {
    // 필수값 입력 누락 있는 경우
    if (!this.title || !this.content) {
      this.alertService.errormsg('입력되지 않은 내용이 있습니다. \n 확인 후 다시 시도해주세요.');
      return;
    }
    // 필수값 모두 입력 시 마케팅 수신 동의 한 고객한테만 푸시 보내기 
    this.alertService.successConfirm('선택하신 고객에게 푸시 알림을 전송하시겠습니까?\n탈퇴 인원에게는 전송되지 않습니다.', '전송하기').then(async ok => {
      if (ok) {
        await Promise.all(
          this.members.map(async (member) => {
            console.log(member);

            const id = this.commonService.generateFilename()
            const updateInfo: Notification = {
              id,
              uuid: member.uuid['uuid'] || member.uuid,
              dateCreated: new Date().toISOString(),
              readSwitch: false,
              title: this.title,
              content: this.content,
              url: `/notification-detail?id=${id}`,
            };
            await this.db.updateAt(`notifications/${updateInfo.id}`, updateInfo);
            if (member.marketingSwitch) {
              await this.pushService.sendPush(member.pushId, this.content, {
                url: '/notification'
              }, this.title)
            }
          })
        );
        this.alertService.swalToast('알림이 전송되었습니다.');
        this.modalService.dismissAll();
      }
    });
  }
}
